import React from "react";
import { useParams } from "react-router-dom";
import styles from "./ServicesIndividualPage.module.scss";
import { useNavigate } from "react-router-dom";
const ServicesIndividualPage = () => {
  const { slug } = useParams();
  const data = fetchDataBasedOnSlug(slug);
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate("/contact"); // Navigate to the specified route
  };
  return (
    <section className={styles.transformSection}>
      <div className={styles.content}>
        <h1>{data.heading}</h1>
        <p dangerouslySetInnerHTML={{ __html: data.description }}></p>

        <button className={styles.ctaButton} onClick={() => handleNavigation()}>
          Let’s get started on your project.
        </button>
      </div>
      <div className={styles.imageWrapper}>
        <img src={data.img} alt="SAP Digital Transformation" />
      </div>
    </section>
  );
};
const fetchDataBasedOnSlug = (slug) => {
  const data = {
    consulting: {
      heading: "Consulting & Implementation",
      description: `SAP is known to simplify business operations irrespective of global scale. However, the key to sucess is to have a well experienced consulting team with on-ground delivery capabilities. and avoid pitfalls of SAP Implementations with SEALKLOUD's consulting team with proven skills.
      <br/>
<br/>
SealKloud as a leading SAP consulting company, have highly-skilled and well-experienced SAP professionals to enable our customers to run their business on SAP, all the while lowering the operational cost.
<br/>
<br/>
As your primary SAP S4/HANA implementation partner to hand-hold you through your digital business transformation, we help your business become an intelligent enterprise by helping you set a vision and foundation for future innovation.
<br/>
<br/>
We offer outcome-focused services, proactive support offerings, intelligent tools and platforms, a global team of experts, and value-added partnerships to bring that vision into reality.
<br/>
<br/>
Our unbiased advice would be the path best suited for your enterprise and the specific challenges. It is the best way carry out any consulting and implementation project.`,
      img: "/assests/services/consulting.jpg",
    },
    "project-management": {
      heading: "Project Management",
      description: `1. Strategic Planning
      <br/>
      <br/>
2. Project Planning
<br/><br/>
3 .Project Execution and Monitoring
<br/><br/>
4. Post-Implementation - Operation and AMS Transition Planning.`,
img: "/assests/services/projectmanagement.jpg",
    },
    "cloud-migration": {
      heading: "Cloud Migration",
      description: `Cloud or On Premise, migration is a concerted effort that pays rich dividends in the long term.
<br/><br/>
With SEALKLOUD, implementing S/4HANA as the digital core platform technology, empowers enterprises with the benefits of next-generation, in-memory advanced business solutions.
<br/><br/>
With the richness of real-time analytics, Internet of Things (IoT), Artificial Intelligence (AI), and big data with intelligently driven business models, S/4HANA has revolutionized the enterprise technology  landscape
<br/><br/>
Enterprises can choose different strategies, be it a New Implementation with a combination of SAP and Non-SAP systems, either On-Premise or in the cloud. Alternatively, it be a technology upgrade from ECC to S/4 HANA - On-Premise or in Cloud, could as well be a Landscape transformation engagement with System consolidation or Global deployments, subject matter experts from SEALKLOUD are well versed in stitching these complex processes together with minimal business disruption, optimal timelines and maximum efficiency in any platform.
 `,
 img: "/assests/services/migration.jpg",
    },
    rpa: {
      heading: "Robotic Process Automation",
      description: `SAP Intelligent RPA is the bridge that connects various systems and eliminates unnecessary effort. Effort that can be better utilized by your team to improve productivity, reduce monotony, and create lasting job satisfaction.
<br/><br/>
RPA creates a layer that sits on top of existing systems and processes without having a need to rewrite thousands of lines of code. SAP Robotic Process Automation covers the the process end-to-end, spanning across a multitude of systems, including SAP and Non-SAP solutions.
<br/><br/>
The advantage? In a short amount of time your teams can review existing processes and come up with areas of optimization using RPA.`,
      img: "/assests/services/rpa.jpg",
    },
    "sme-advisory": {
      heading: "SME Advisory",
      description: `SAP Advisory Services support you across the entire innovation lifecycle with the expertise, tools, and resources you need to acquire the visibility, focus, and agility of an intelligent enterprise. It provides customer-centric operations, visionary strategies, and innovative business models like:
<br/><br/>
1. Business And Value Assessment<br/><br/>
2. IT Strategy and Enterprise Architecture Roadmap<br/><br/>
3. Transformation Advisory<br/><br/>
4. Solution Advisory.`,
      img: "/assests/services/sme.jpeg",
    },
    testing: {
      heading: "Testing",
      description: `1. Our testing methodology is simple.<br/><br/>
2. Detailed Functional and Integration Scope<br/><br/>
3. Test Cycles with Time Schedule and Resource Planning<br/><br/>
4. Ready-to-Use Cloud-based Test Tools<br/><br/>
5. Retail and Fashion process driven Test Cases and Test Scripts<br/><br/>
6. Planning of Work Schedule in alignment with<br/><br/>
7. Test Data Management Templates<br/><br/>
8. Test Execution Plans Test Execution Reporting<br/><br/>
9. Defect Management<br/><br/>
10. Test Cycle Entry and Exit Criteria<br/><br/>
11. Defining of Testing Assumptions and Guidelines<br/><br/>
12. Testing Tool Assessment and Identification, Integration, and Implementation.`,
      img: "/assests/services/testing.jpg",
    },
    "sap-s4-hana": {
      heading: "SAP S4 HANA On Premise / Cloud",
      description: `Implementation consideration:<br/><br/>
1. Assessment and Planning*: Conduct a thorough assessment of current systems and processes to plan the migration effectively.<br/><br/>
2. Change Management*: Implement a robust change management strategy to handle the transition and train employees.<br/><br/>
3. Customization and Integration*: Address specific business needs through customization and ensure seamless integration with existing systems.<br/><br/>
4. Performance Monitoring*: Establish metrics and monitoring tools to measure performance and ensure optimal operation post-implementation.`,
      img: "/assests/services/sap.jpg",
    },
  };
  return data[slug];
};
export default ServicesIndividualPage;
